"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEdit = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconEdit = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.238 20.133h-10.7a.595.595 0 010-1.19h10.7a.595.595 0 010 1.19zm-16.644 0a.595.595 0 01-.579-.73l.865-3.667a.588.588 0 01.158-.284L15.967 4.524c.672-.673 1.848-.675 2.522 0l1.12 1.12c.337.337.523.785.523 1.261 0 .477-.186.925-.522 1.261L8.68 19.094a.594.594 0 01-.283.159l-3.666.864a.577.577 0 01-.137.016zm1.404-3.96l-.605 2.566 2.567-.605L18.769 7.326a.59.59 0 000-.84l-1.121-1.122a.608.608 0 00-.84 0L5.998 16.173zM8.3 18.726h.03-.03z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.791 10.738a.59.59 0 01-.42-.175l-2.803-2.802a.595.595 0 11.841-.841l2.803 2.802a.595.595 0 01-.42 1.016z"
})));
exports.IconEdit = IconEdit;
//# sourceMappingURL=IconEdit.js.map